// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_d4j","cls2":"UserCard-cls2_JRj UserCard-cls1_d4j","truncateText":"UserCard-truncateText_-d3"};